// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'

import {
  OpenInNewTab,
  PassiveTrigger,
} from './common'

// RE: LEGO-5254
// See components/DataTable/Row for details on
// what's happening here with event handling.

class ProjectPathInfo extends React.Component {
  static propTypes = {
    columnKey: string.isRequired,
    customProps: object.isRequired,
    idRoot: string.isRequired,
    rowData: object.isRequired,
    TooltipTrigger: func.isRequired,
  }

  state = {
    mouseDownX: null,
    mouseDownY: null,
  }

  pathIndexStyle = { width: '30px' }

  handleClick = e => {
    const {
      clientX,
      clientY,
    } = e

    const {
      customProps,
      rowData,
    } = this.props

    const {
      highlightRows,
      rowHighlightToggle,
    } = customProps

    // if we're not supposed to highlight rows,
    // let the click event bubble up.
    if (!highlightRows) {
      return e
    } else {
      e.stopPropagation()
    }

    const {
      mouseDownX,
      mouseDownY,
    } = this.state

    this.setState(() => ({
      mouseDownX: null,
      mouseDownY: null,
    }))

    // This component is used as a child of that and we need to manage event
    // propagation/bubbling between these two.
    if (
      Math.abs(mouseDownX - clientX) < 10 &&
      Math.abs(mouseDownY - clientY) < 10
    ) {
      const uniqueValue = rowData[rowData.uniqueId]
      return rowHighlightToggle(uniqueValue)
    }
  }

  // capture coordinates for where the user fired mousedown
  handleMouseDown = ({ clientX, clientY }) => (
    this.setState(() => ({
      mouseDownX: clientX,
      mouseDownY: clientY,
    }))
  )

  render () {
    const {
      columnKey,
      idRoot,
      rowData,
      TooltipTrigger,
    } = this.props

    const {
      band,
      passiveSummary,
      pathId,
      pathIndex,
      pathName,
      projectName,
      projectId,
    } = rowData

    return (
      <div
        className={'path-summary-path-info-cell path-summary-cell'}
        onClick={this.handleClick}
        onMouseDown={this.handleMouseDown}
        title={`Path Id: ${pathId}`}>
        <div className={'path-summary-site-cell'}>
          <span
            id={`${idRoot}-path-index`}
            style={this.pathIndexStyle}>{pathIndex}</span>
          <strong
            className={'text-ellipsis margin-right-auto'}
            id={`${idRoot}-project-name`}>
            {projectName}
          </strong>
          <span id={`${idRoot}-path-band`}>{band}</span>
        </div>
        <div className={'path-summary-site-cell'}>
          <OpenInNewTab
            idRoot={idRoot}
            newPath={`/project-management/${projectId}/path-details/${pathId}`} />
          <span
            className={'text-ellipsis margin-right-auto'}
            id={`${idRoot}-path-name`}>
            {`Path: ${pathName || ''}`}
          </span>
          <PassiveTrigger
            columnKey={columnKey}
            idRoot={idRoot}
            passiveSummary={passiveSummary}
            TooltipTrigger={TooltipTrigger} />
        </div>
      </div>
    )
  }
}

export default ProjectPathInfo
